const getDycAssetPath = (folder: "images" | "pdf", fileName: string) =>
  `${process.env.PUBLIC_URL || ""}/DYC/${folder}/${encodeURIComponent(fileName)}`;

export const posterSlides = [
  {
    src: getDycAssetPath("images", "spotlight.png"),
    alt: "Spotlight",
  },
  {
    src: getDycAssetPath("images", "jam.png"),
    alt: "JAM (Just A Minute)",
  },
  {
    src: getDycAssetPath("images", "ecomosaic.png"),
    alt: "Eco - Mosaic",
  },
  {
    src: getDycAssetPath("images", "faithvault.png"),
    alt: "The Faith Vault",
  },
  {
    src: getDycAssetPath("images", "pitchbattle.png"),
    alt: "Pitch Battle",
  },
  {
    src: getDycAssetPath("images", "samesame.png"),
    alt: "Same Same But Different",
  },
  {
    src: getDycAssetPath("images", "shortfilm.png"),
    alt: "Film Rush",
  },
  {
    src: getDycAssetPath("images", "rhythmroots.png"),
    alt: "Rhythm and Roots",
  },
] as const;

export const registrationContacts = [
  {
    name: "Alson Mathias",
    role: "President",
    phone: "+91 8861279454",
  },
  {
    name: "Clinton Suares",
    role: "Sports and Cultural Secretary",
    phone: "+91 96063 43644",
  },
  {
    name: "Joyel Nazareth",
    role: "Treasurer",
    phone: "+91 91486 51627",
  },
] as const;

export const paymentDetails = {
  name: "Joyel Nazareth",
  upiId: "9148651627@axl",
  phone: "+91 91486 51627",
  qrCodePath: getDycAssetPath("images", "qrcode.png"),
} as const;

export const onlineEvents = [
  {
    id: "same-same-but-different",
    title: "Same Same But Different - Reel Competition",
    description: ` Recreate a famous advertisement in your own unique style while preserving its core message, adding creativity through humour, modern twists, or fresh storytelling.
End your video with a creative promotion of YUVA DABAZO 2026, showcasing your team's acting, teamwork, and video production skills. `,
    pdfPath: getDycAssetPath("pdf", "Same Same But Different - Online Competition.pdf"),
  },
  {
    id: "film-rush",
    title: "Film Rush - Short Film Competition",
    description: `Every frame tells a story, every story leaves an impact.
Bring your vision to life through the power of cinema.`,
    pdfPath: getDycAssetPath("pdf", "Film Rush  Short Film Competition Rules and Guidelines.pdf"),
  },
] as const;

export const dayEventItems = [
  "SpotLight",
  "JAM( Just A Minute)",
  "Eco - Mosaic",
  "The Faith Vault",
  "Pitch Battle",
] as const;

export const dayEventsPdfPath =
  getDycAssetPath("pdf", "Yuva Dabazo 2026 Competition Rules and Guidelines.pdf");
export const generalRulesPdfPath = getDycAssetPath("pdf", "General_instructions_yuva_dabazo.pdf");
export const registrationFormPdfPath = getDycAssetPath("pdf", "Registration Form Yuva Dabazo.pdf");
export const pitchBattleLastDateLabel = "August 31, 2026";

export const eventOptions = [
  { id: "spotlight", label: "SpotLight" },
  { id: "jam", label: "JAM (Just A Minute)" },
  { id: "ecomosaic", label: "Eco - Mosaic" },
  { id: "faithvault", label: "The Faith Vault" },
  { id: "pitchbattle", label: "Pitch Battle" },
  { id: "rhythmroots", label: "Rhythm and Roots" },
] as const;

export type EventId = (typeof eventOptions)[number]["id"];
export type RegistrationEventId = EventId;

export type EventFormState = Record<RegistrationEventId, unknown> & {
  spotlight: {
    performingEventName: string;
    eventDescription: string;
    teamLeadContact: string;
    participantCount: string;
    participantNames: string[];
  };
  jam: {
    participantName: string;
    participantContact: string;
  };
  ecomosaic: {
    primaryName: string;
    primaryContact: string;
    hasSecondParticipant: boolean;
    secondaryName: string;
    secondaryContact: string;
  };
  faithvault: {
    teamLeadContact: string;
    memberNames: string[];
  };
  pitchbattle: {
    confirmed: boolean;
  };
  rhythmroots: {
    participantCount: string;
    participantNames: string[];
  };
};

export const defaultEventForms = (): EventFormState => ({
  spotlight: {
    performingEventName: "",
    eventDescription: "",
    teamLeadContact: "",
    participantCount: "1",
    participantNames: ["", "", "", "", ""],
  },
  jam: {
    participantName: "",
    participantContact: "",
  },
  ecomosaic: {
    primaryName: "",
    primaryContact: "",
    hasSecondParticipant: false,
    secondaryName: "",
    secondaryContact: "",
  },
  faithvault: {
    teamLeadContact: "",
    memberNames: ["", "", ""],
  },
  pitchbattle: {
    confirmed: true,
  },
  rhythmroots: {
    participantCount: "1",
    participantNames: Array(50).fill(""),
  },
});

export const getParticipantNamesList = (value: string) =>
  value
    .split("\n")
    .map((name) => name.trim())
    .filter(Boolean);

export const pitchBattleParticipantOptions = ["1", "2", "3", "4", "5"] as const;

export const sanitizePhone = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) {
    return digits.slice(2);
  }
  if (digits.length === 11 && digits.startsWith("0")) {
    return digits.slice(1);
  }
  return digits.slice(0, 10);
};

